// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPerson = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 2a4 4 0 100 8 4 4 0 000-8m-2 4a2 2 0 114 0 2 2 0 01-4 0m2 6c-1.373 0-2.86.273-4.205.744-1.336.467-2.61 1.157-3.502 2.049L4 15.086V21h16v-5.914l-.293-.293c-.892-.892-2.166-1.582-3.502-2.05C14.86 12.274 13.374 12 12 12m-6 7v-3.059c.607-.504 1.463-.962 2.455-1.31C9.61 14.227 10.874 14 12 14c1.127 0 2.39.227 3.545.631.993.348 1.847.806 2.455 1.31V19z"
    />
  );
export default SvgIconPerson;
